import Generate from "./generate.container";

export default Generate;
